import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Collections, Objects} from "components";

import {Button} from "reactstrap";
import UniversalModalOverride from "components/UniversalModalOverride";


const breadcrumbsStatic = [
	{
		name: 'Dashboard',
		url: '/',
		icon: 'dashboard',
	},
	{
		name: 'Kiosks',
		url: '/kiosks',
		icon: 'tablet',
	},
];

export default class Kiosks extends Framework.Components.View {
	render() {
		return (
			<div className="container-fluid">

				<Framework.Components.PageBar breadcrumbs={breadcrumbsStatic} history={this.props.history}>
					<Button data-id="add-kiosk" onClick={this.toggle('modalKiosk')} size="sm" color="primary">
						<i className="fa fa-tablet"/>&nbsp;&nbsp;Add Kiosk
					</Button>
				</Framework.Components.PageBar>

				<Collections.Kiosks
					history={this.props.history}
					locations={this.props.locations}
					states={this.props.states}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
					account={this.props.account}
				/>

				<UniversalModalOverride
					account={this.props.account}
					locations={this.props.locations}
					states={this.props.states}
					name="Kiosk"
					object={Objects.Kiosk}
					history={this.props.history}
					toggle={this.state['modalKiosk']}
					reportClose={this.reportClose('modalKiosk')}
					afterSave={this.handleAfterSave}
				/>

			</div>
		);
	}
}


